import React, { useEffect, useState } from "react";
import Select from "react-select";
import CreatableSelect from 'react-select/creatable';
import "./react-select.css";
import {
  GET_KECAMATAN_LOOKUP,
  GET_LOOK_UP_CITY,
  GET_LOOK_UP_COUNTRY,
  GET_PROFESSION_LOOKUP,
  GET_PROVINCE_API_WILAYAHID,
  GET_PROVINCE_LOOKUP,
  GET_RELIGION_LOOKUP,
} from "../API";
import LoadingBtn from "../../../Widgets/LoadingBtn";
import { AlertNotifRetry } from "../../../../Library/AlertNotif";
import { CapitalizeEachWord, EncodeURIComponentSafe } from "../../../../Library/GlobalHelper";

const customStyles = {
  menuPortal: (provided) => ({ ...provided, zIndex: 9999 }),
  menu: (provided) => ({ ...provided, zIndex: 9999 }),
};

export function SelectProvince({ data, setData, isSolid = false }) {
  const [selected, setSelected] = useState(data || "");
  const [options, setOptions] = useState([]);
  const [selectedOption, setSelectedOption] = useState([]);
  const [result, setResult] = useState({
    loading: false,
    message: "",
    data: [],
  });
  const ReloadData = async () => {
    setResult({
      loading: true,
      message: "",
      data: [],
    });

    const result = await GET_PROVINCE_LOOKUP({ "": "" });

    if (result.data && Object.values(result.data).length > 0) {
      const option_result = result.data.map((v) => {
        let obj = {};
        obj.value = v.id;
        obj.label = v.name;
        return obj;
      });
      setOptions(option_result);

      if (selected) {
        const findSelected = option_result.find(
          (item) => item.value === selected
        );
        setSelectedOption(findSelected);
      }
      setResult(result);
    } else {
      setResult(result);
    }
  };

  useEffect(() => {
    ReloadData();
  }, []);

  const HandleChange = (option) => {
    if (option) {
      setSelectedOption(option);
      setSelected(option.value);
      setData(option.value);
    } else {
      setSelectedOption(null);
      setSelected("");
      setData("");
    }
  };

  if (result.loading) {
    return <LoadingBtn />;
  } else if (result.message) {
    return <AlertNotifRetry messages={result.message} Reload={ReloadData} />;
  } else {
    return (
      <div
        className={
          isSolid
            ? "form-select-two form-select-two-solid form-select-two-lg"
            : ""
        }
      >
        <Select
          name="degree_types"
          classNamePrefix="react-select"
          value={selectedOption}
          onChange={HandleChange}
          options={options}
          placeholder={"Select a province"}
          styles={customStyles}
          menuPortalTarget={document.body}
          menuPosition="fixed"
          components={{
            IndicatorSeparator: () => null,
          }}
          isClearable
        />
      </div>
    );
  }
}

export function SelectCountry({ data, setData, isSolid = false, setCountryName }) {
  const [selected, setSelected] = useState(data || "");
  const [options, setOptions] = useState([]);
  const [selectedOption, setSelectedOption] = useState([]);
  const [result, setResult] = useState({
    loading: false,
    message: "",
    data: [],
  });
  const ReloadData = async () => {
    setResult({
      loading: true,
      message: "",
      data: [],
    });

    const result = await GET_LOOK_UP_COUNTRY({ "": "" });

    if (result.data && Object.values(result.data).length > 0) {
      const option_result = result.data.map((v) => {
        let obj = {};
        obj.value = v.id;
        obj.label = v.name;
        return obj;
      });
      setOptions(option_result);

      if (selected) {
        const findSelected = option_result.find(
          (item) => item.value === selected
        );
        setSelectedOption(findSelected);
      }
      setResult(result);
    } else {
      setResult(result);
    }
  };

  useEffect(() => {
    ReloadData();
  }, []);

  const HandleChange = (option) => {
    if (option) {
      setSelectedOption(option);
      setSelected(option.value);
      setData(option.value);
      if(setCountryName){
        setCountryName(option.label);
      }
    } else {
      setSelectedOption(null);
      setSelected("");
      setData("");
      if(setCountryName){
        setCountryName("");
      }
    }
  };

  if (result.loading) {
    return <LoadingBtn />;
  } else if (result.message) {
    return <AlertNotifRetry messages={result.message} Reload={ReloadData} />;
  } else {
    return (
      <div
        className={
          isSolid
            ? "form-select-two form-select-two-solid form-select-two-lg"
            : ""
        }
      >
        <Select
          name="degree_types"
          classNamePrefix="react-select"
          value={selectedOption}
          onChange={HandleChange}
          options={options}
          placeholder={"Select a country"}
          styles={customStyles}
          menuPortalTarget={document.body}
          menuPosition="fixed"
          components={{
            IndicatorSeparator: () => null,
          }}
          isClearable
        />
      </div>
    );
  }
}

export function SelectCity({ data, setData, isSolid = false }) {
  const [selected, setSelected] = useState(data || "");
  const [options, setOptions] = useState([]);
  const [selectedOption, setSelectedOption] = useState([]);
  const [result, setResult] = useState({
    loading: false,
    message: "",
    data: [],
  });
  const ReloadData = async () => {
    setResult({
      loading: true,
      message: "",
      data: [],
    });

    const result = await GET_LOOK_UP_CITY({ "": "" });

    if (result.data && Object.values(result.data).length > 0) {
      const option_result = result.data.map((v) => {
        let obj = {};
        obj.value = v.id;
        obj.label = v.name;
        return obj;
      });
      setOptions(option_result);

      if (selected) {
        const findSelected = option_result.find(
          (item) => item.value === selected
        );
        setSelectedOption(findSelected);
      }
      setResult(result);
    } else {
      setResult(result);
    }
  };

  useEffect(() => {
    ReloadData();
  }, []);

  const HandleChange = (option) => {
    if (option) {
      setSelectedOption(option);
      setSelected(option.value);
      setData(option.value);
    } else {
      setSelectedOption(null);
      setSelected("");
      setData("");
    }
  };

  if (result.loading) {
    return <LoadingBtn />;
  } else if (result.message) {
    return <AlertNotifRetry messages={result.message} Reload={ReloadData} />;
  } else {
    return (
      <div
        className={
          isSolid
            ? "form-select-two form-select-two-solid form-select-two-lg"
            : ""
        }
      >
        <Select
          name="degree_types"
          classNamePrefix="react-select"
          value={selectedOption}
          onChange={HandleChange}
          options={options}
          placeholder={"Select a city"}
          styles={customStyles}
          menuPortalTarget={document.body}
          menuPosition="fixed"
          components={{
            IndicatorSeparator: () => null,
          }}
          isClearable
        />
      </div>
    );
  }
}

export function SelectCityByText({ data, setData, isSolid = false }) {
  const [selected, setSelected] = useState(data || "");
  const [options, setOptions] = useState([]);
  const [selectedOption, setSelectedOption] = useState([]);
  const [result, setResult] = useState({
    loading: false,
    message: "",
    data: [],
  });
  const ReloadData = async () => {
    setResult({
      loading: true,
      message: "",
      data: [],
    });

    const result = await GET_LOOK_UP_CITY({ "": "" });

    if (result.data && Object.values(result.data).length > 0) {
      const option_result = result.data.map((v) => {
        let obj = {};
        obj.value = v.id;
        obj.label = v.name;
        return obj;
      });
      setOptions(option_result);

      if (selected) {
        const findSelected = option_result.find(
          (item) => item.label.toLowerCase() === selected.toLowerCase()
        );
        setSelectedOption(findSelected);
      }
      setResult(result);
    } else {
      setResult(result);
    }
  };

  useEffect(() => {
    ReloadData();
  }, []);

  const HandleChange = (option) => {
    if (option) {
      setSelectedOption(option);
      setSelected(option.value);
      setData(option.label);
    } else {
      setSelectedOption(null);
      setSelected("");
      setData("");
    }
  };

  if (result.loading) {
    return <LoadingBtn />;
  } else if (result.message) {
    return <AlertNotifRetry messages={result.message} Reload={ReloadData} />;
  } else {
    return (
      <div
        className={
          isSolid
            ? "form-select-two form-select-two-solid form-select-two-lg"
            : ""
        }
      >
        <Select
          name="degree_types"
          classNamePrefix="react-select"
          value={selectedOption}
          onChange={HandleChange}
          options={options}
          placeholder={"Select a city"}
          styles={customStyles}
          menuPortalTarget={document.body}
          menuPosition="fixed"
          components={{
            IndicatorSeparator: () => null,
          }}
          isClearable
        />
      </div>
    );
  }
}

export function SelectReligi({ data, setData, isSolid = false }) {
  const [selected, setSelected] = useState(data || "");
  const [options, setOptions] = useState([]);
  const [selectedOption, setSelectedOption] = useState([]);
  const [result, setResult] = useState({
    loading: false,
    message: "",
    data: [],
  });
  const ReloadData = async () => {
    setResult({
      loading: true,
      message: "",
      data: [],
    });

    const result = await GET_RELIGION_LOOKUP({ "": "" });

    if (result.data && Object.values(result.data).length > 0) {
      const option_result = result.data.map((v) => {
        let obj = {};
        obj.value = v.id;
        obj.label = v.name;
        return obj;
      });
      setOptions(option_result);

      if (selected) {
        const findSelected = option_result.find(
          (item) => item.value === selected
        );
        setSelectedOption(findSelected);
      }
      setResult(result);
    } else {
      setResult(result);
    }
  };

  useEffect(() => {
    ReloadData();
  }, []);

  const HandleChange = (option) => {
    if (option) {
      setSelectedOption(option);
      setSelected(option.value);
      setData(option.value);
    } else {
      setSelectedOption(null);
      setSelected("");
      setData("");
    }
  };

  if (result.loading) {
    return <LoadingBtn />;
  } else if (result.message) {
    return <AlertNotifRetry messages={result.message} Reload={ReloadData} />;
  } else {
    return (
      <div
        className={
          isSolid
            ? "form-select-two form-select-two-solid form-select-two-lg"
            : ""
        }
      >
        <Select
          name="degree_types"
          classNamePrefix="react-select"
          value={selectedOption}
          onChange={HandleChange}
          options={options}
          placeholder={"Choose One"}
          styles={customStyles}
          menuPortalTarget={document.body}
          menuPosition="fixed"
          components={{
            IndicatorSeparator: () => null,
          }}
          isClearable
        />
      </div>
    );
  }
}

export function SelectProfession({ data, setData, isSolid = false }) {
  const [selected, setSelected] = useState(data || "");
  const [options, setOptions] = useState([]);
  const [selectedOption, setSelectedOption] = useState([]);
  const [result, setResult] = useState({
    loading: false,
    message: "",
    data: [],
  });
  const ReloadData = async () => {
    setResult({
      loading: true,
      message: "",
      data: [],
    });

    const result = await GET_PROFESSION_LOOKUP({ "": "" });

    if (result.data && Object.values(result.data).length > 0) {
      const without_oth = result.data.filter(v => v.id !== 4);
      const option_result = without_oth.map((v) => {
        let obj = {};
        obj.value = v.id;
        obj.label = v.name;
        return obj;
      });
      setOptions(option_result);

      if (selected) {
        const findSelected = option_result.find(
          (item) => item.value === selected
        );
        setSelectedOption(findSelected);
      }
      setResult(result);
    } else {
      setResult(result);
    }
  };

  useEffect(() => {
    ReloadData();
  }, []);

  const HandleChange = (option) => {
    if (option) {
      setSelectedOption(option);
      setSelected(option.value);
      setData(option.value);
    } else {
      setSelectedOption(null);
      setSelected("");
      setData("");
    }
  };

  if (result.loading) {
    return <LoadingBtn />;
  } else if (result.message) {
    return <AlertNotifRetry messages={result.message} Reload={ReloadData} />;
  } else {
    return (
      <div
        className={
          isSolid
            ? "form-select-two form-select-two-solid form-select-two-lg"
            : ""
        }
      >
        <Select
          name="degree_types"
          classNamePrefix="react-select"
          value={selectedOption}
          onChange={HandleChange}
          options={options}
          placeholder={"Select a profession"}
          styles={customStyles}
          menuPortalTarget={document.body}
          menuPosition="fixed"
          components={{
            IndicatorSeparator: () => null,
          }}
          isClearable
        />
      </div>
    );
  }
}

export function SelectInputProfession({ data, setData, data_oth, setOth, isSolid = false, disabled=false }) {
  const [selected, setSelected] = useState(data || "");
  const [options, setOptions] = useState([]);
  const [selectedOption, setSelectedOption] = useState(null);
  const [result, setResult] = useState({
    loading: false,
    message: "",
    data: [],
  });

  const ReloadData = async () => {
    setResult({
      loading: true,
      message: "",
      data: [],
    });

    const result = await GET_PROFESSION_LOOKUP({ "": "" });

    if (result.data && Object.values(result.data).length > 0) {
      const without_oth = result.data.filter(v => v.id !== 4);
      const option_result = without_oth.map((v) => ({
        value: v.id,
        label: v.name,
      }));
      setOptions(option_result);

      if (selected) {
        if (selected === 4) {
          setSelectedOption({ value: 4, label: data_oth });
        } else {
          const findSelected = option_result.find(
            (item) => item.value === selected
          );
          setSelectedOption(findSelected);
        }
      }
      setResult(result);
    } else {
      setResult(result);
    }
  };

  useEffect(() => {
    ReloadData();
  }, []);

  const HandleChange = (newValue) => {
    if (newValue) {
      setSelectedOption(newValue);
      setSelected(newValue.value);
      setData(newValue.value);
    } else {
      setSelectedOption(null);
      setSelected("");
      setData("");
    }
  };

  const HandleCreate = (inputValue) => {
    const newOption = { value: 4, label: CapitalizeEachWord(inputValue) };
    setOptions([...options, newOption]);
    setSelectedOption(newOption);
    setSelected(newOption.value);
    setData(newOption.value);
    if (newOption.value === 4) {
      setOth(newOption.label);
    } else {
      setOth("");
    }
  };

  if (result.loading) {
    return <LoadingBtn />;
  } else if (result.message) {
    return <AlertNotifRetry messages={result.message} Reload={ReloadData} />;
  } else {
    return (
      <div
        className={
          isSolid
            ? "form-select-two form-select-two-solid form-select-two-lg"
            : ""
        }
      >
        <CreatableSelect
          name="profession"
          classNamePrefix="react-select"
          value={selectedOption}
          onChange={HandleChange}
          onCreateOption={HandleCreate}
          options={options}
          placeholder={"Select or type a profession"}
          styles={customStyles}
          disabled={disabled}
          menuPortalTarget={document.body}
          menuPosition="fixed"
          components={{
            IndicatorSeparator: () => null,
          }}
          isClearable
        />
      </div>
    );
  }
}

export function SelectProvinceWilayahID({ data, setData, isSolid = false }) {
  const [selected, setSelected] = useState(data || "");
  const [options, setOptions] = useState([]);
  const [selectedOption, setSelectedOption] = useState([]);
  const [result, setResult] = useState({
    loading: false,
    message: "",
    data: [],
  });
  const ReloadData = async () => {
    setResult({
      loading: true,
      message: "",
      data: [],
    });

    try {
      const [result, r_province] = await Promise.all([
        GET_PROVINCE_LOOKUP({ "": "" }),
        GET_PROVINCE_API_WILAYAHID()
      ]);

      if (result.data && Object.values(result.data).length > 0) {
        let combinedData = result.data;
        if (r_province.data && Object.values(r_province.data).length > 0) {
          combinedData = result.data.map(provinceWilayah => {
            const matchingProvince = r_province.data.find(p => p.name.toLowerCase() === provinceWilayah.name.toLowerCase());
            return {
              ...provinceWilayah,
              code: matchingProvince ? (matchingProvince.code) : null
            };
          });
        }
        console.log(combinedData);
        const option_result = combinedData.map((v) => ({
          value: v.id,
          label: v.name,
          code: v.code
        }));

        setOptions(option_result);

        if (selected) {
          const findSelected = option_result.find(
            (item) => item.value === selected
          );
          setSelectedOption(findSelected);
        }
        setResult({ ...result, data: combinedData });
      } else {
        setResult({ loading: false, message: "No data found or API error", data: [] });
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setResult({ loading: false, message: "Error fetching data", data: [] });
    }
  };

  useEffect(() => {
    ReloadData();
  }, []);

  const HandleChange = (option) => {
    if (option) {
      setSelectedOption(option);
      setSelected(option.value);
      setData(option.value);
      console.log(option.code);
    } else {
      setSelectedOption(null);
      setSelected("");
      setData("");
    }
  };

  if (result.loading) {
    return <LoadingBtn />;
  } else if (result.message) {
    return <AlertNotifRetry messages={result.message} Reload={ReloadData} />;
  } else {
    return (
      <div
        className={
          isSolid
            ? "form-select-two form-select-two-solid form-select-two-lg"
            : ""
        }
      >
        <Select
          name="degree_types"
          classNamePrefix="react-select"
          value={selectedOption}
          onChange={HandleChange}
          options={options}
          placeholder={"Select a province"}
          styles={customStyles}
          menuPortalTarget={document.body}
          menuPosition="fixed"
          components={{
            IndicatorSeparator: () => null,
          }}
          isClearable
        />
      </div>
    );
  }
}

export function SelectKecamatan({ data, setData, isSolid = false, city_id }) {
  const [inputValue, setInputValue] = useState("");
  const [selected, setSelected] = useState(data || "");
  const [options, setOptions] = useState([]);
  const [selectedOption, setSelectedOption] = useState([]);
  const [result, setResult] = useState({
    loading: false,
    message: "",
    data: [],
  });
  const ReloadData = async (param) => {
    setResult({
      loading: true,
      message: "",
      data: [],
    });

    const result = await GET_KECAMATAN_LOOKUP(param);

    if (result.data && Object.values(result.data).length > 0) {
      const option_result = result.data.map((v) => {
        let obj = {};
        obj.value = v.id;
        obj.label = v.name;
        return obj;
      });
      setOptions(option_result);

      if (selected) {
        const findSelected = option_result.find(
          (item) => item.value === selected
        );
        setSelectedOption(findSelected);
      }
      setResult(result);
    } else {
      setResult(result);
    }
  };

  useEffect(() => {
    ReloadData();
  }, [selected]);

  const FindData = (value) => {
    const input_value = value.toLowerCase();

    if (input_value.length > 3) {
      const param = { search: EncodeURIComponentSafe(input_value) }
      ReloadData(param);
    } else {
      setOptions([]);
    }

    setInputValue(input_value);
  }

  const HandleChange = (option) => {
    if (option) {
      setSelectedOption(option);
      setSelected(option.value);
      setData(option.value);
    } else {
      setSelectedOption(null);
      setSelected("");
      setData("");
    }
  };

  return (
    <div
      className={
        isSolid
          ? "form-select-two form-select-two-solid form-select-two-lg"
          : ""
      }
    >
      <div className="d-flex align-items-center">
        <div className="w-100">
          <Select
            name="degree_types"
            classNamePrefix="react-select"
            value={selectedOption}
            onChange={HandleChange}
            options={options}
            onInputChange={FindData}
            inputValue={inputValue}
            placeholder={"type min 3 character"}
            styles={customStyles}
            menuPortalTarget={document.body}
            menuPosition="fixed"
            components={{
              IndicatorSeparator: () => null,
            }}
            isClearable
          />
        </div>
        {result.loading && <LoadingBtn />}
      </div>
    </div>
  );
}

